import { object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { dateRangeValidationSchema } from '~/utils/validate';

const validationSchema = object().shape({
  ...dateRangeValidationSchema,
});

export default yupResolver(validationSchema);
